import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const CreditsSection = () => {
  return <section className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-1036" data-mp="2ldc4v087n0u1">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black opacity-20" data-id="element-1037" data-mp="2pfh186q1mbkd"></div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-1038" data-mp="2u65qdfe92wgc">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-1039" data-mp="2z58xr6hpderh">
          <div className="w-24 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-1040" data-mp="3d3qhyu8eg94n"></div>
          <h2 className="font-serif text-4xl md:text-5xl text-amber-400 tracking-wider uppercase" data-id="element-1041" data-mp="1epx9dtbpz9xm">
            Credits
          </h2>
        </motion.div>
        {/* Presented By */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20" data-id="element-1042" data-mp="l70y374hnl8m">
          <div className="border border-amber-400/30 p-8 bg-black/40 text-center" data-id="element-1043" data-mp="6jpm544e9z7z">
            <h3 className="text-amber-400 font-light text-sm tracking-[0.3em] uppercase mb-4" data-id="element-1044" data-mp="146ex43h2rm5z">
              Proudly Presented By
            </h3>
            <div className="w-16 h-px bg-amber-400/30 mx-auto mb-6" data-id="element-1045" data-mp="z4z8y2jlozjd"></div>
            <p className="text-white text-lg font-light tracking-wider" data-id="element-1046" data-mp="u6e8q34cmfux">
              Akal Steel (2005) Inc.
            </p>
          </div>
        </motion.div>
        {/* In Memory */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-1047" data-mp="3ez9fe352fhn1">
          <div className="border-2 border-amber-400/30 p-12 bg-black/60 text-center" data-id="element-1048" data-mp="25z5dzlmoy691">
            <h3 className="font-serif text-3xl text-amber-400 mb-8 tracking-wider uppercase" data-id="element-1049" data-mp="1s18kiy3jafyl">
              In Memory
            </h3>
            <div className="w-20 h-px bg-amber-400/30 mx-auto mb-8" data-id="element-1050" data-mp="1ibxczfwapjct"></div>
            <p className="text-white text-sm mb-6 tracking-wider uppercase font-light" data-id="element-1051" data-mp="1i9kloc4ndwn3">
              With Gratitude to Sardar Surinder Kundan Singh
            </p>
            <p className="text-white/70 text-xs mb-6 tracking-wider uppercase font-light leading-relaxed" data-id="element-1052" data-mp="19ca82k4cxvf0">
              Founding Chairman, Scarborough Gurdwara • Original Sevadar, Art of
              the Sikh Kingdoms (1947-2012)
            </p>
            <p className="text-white/50 text-xs tracking-wider uppercase font-light" data-id="element-1053" data-mp="14bwaxx4ao5vr">
              This work—from the anonymous creator of Sikhiwiki & Turbanizer—is
              created in his memory
            </p>
          </div>
        </motion.div>
        {/* Credits Grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-1054" data-mp="gqlozp1g9tjb">
          {/* Executive Producers */}
          <div data-id="element-1055" data-mp="zn4qbs60id5b">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1056" data-mp="zlk5iu9i28kn">
              Executive Producers
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1057" data-mp="18ggnab7actk4">
              Jasvinder Singh
              <br data-id="element-1058" data-mp="1iduv5mf58a0t" />
              Baljeet Kaur
              <br data-id="element-1059" data-mp="1if5tv7tqerl2" />
              Harsimran Kaur (M/O Akaash Singh & Baani Kaur)
              <br data-id="element-1060" data-mp="3bxd7jioasapq" />
              Aiksimar Singh
              <br data-id="element-1061" data-mp="3buinvtd3ytxd" />
              JJ Singh Brar
            </p>
          </div>
          {/* Creative Direction */}
          <div data-id="element-1062" data-mp="3lmemr6n0qo2n">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1063" data-mp="3llv4fotghxo3">
              Creative Direction
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1064" data-mp="2sxqwsxrbrair">
              Kanwar Singh Dhillon
              <br data-id="element-1065" data-mp="2xxveus7vsdb3" />
              Inkquisitive
            </p>
          </div>
          {/* Sound Engineering */}
          <div data-id="element-1066" data-mp="32v40j2s8mzh3">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1067" data-mp="32ulsza04kytv">
              Sound Engineering
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1068" data-mp="i4wfp1f2ll3a">
              J-Statik
            </p>
          </div>
          {/* Musical Score */}
          <div data-id="element-1069" data-mp="27lrzuvnn5yuh">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1070" data-mp="27libfci8vzqw">
              Musical Score
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1071" data-mp="1xw8hdr3uc705">
              DJ Singhchronize
            </p>
          </div>
          {/* Historical Consultants */}
          <div data-id="element-1072" data-mp="1nz2n69zxjzvp">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1073" data-mp="1nzlw517lrdxl">
              Historical Consultants
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1074" data-mp="1ez78vwb2vorg">
              Sarbpreet Singh
              <br data-id="element-1075" data-mp="1a0vxhh54x674" />
              Prableen Kamboj
              <br data-id="element-1076" data-mp="39cozjs6s51qp" />
              Ajaypal Singh
            </p>
          </div>
          {/* Immersive Technology */}
          <div data-id="element-1077" data-mp="34e40hw39ko3u">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1078" data-mp="34dlui7qsuviq">
              Immersive Technology
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1079" data-mp="17foiv63f2v9d">
              Secret Location
              <br data-id="element-1080" data-mp="srjw9r18tzlb" />
              ATHINK AI Studio
            </p>
          </div>
          {/* Culinary Direction */}
          <div data-id="element-1081" data-mp="xmh3qtivk0w3">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1082" data-mp="1lenxrm14nvsc">
              Culinary Direction
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1083" data-mp="1qb4v96u7vmi3">
              Gagan Grewal-Sagoo
              <br data-id="element-1084" data-mp="1geidiqx6tbka" />
              Baani Kundan Kaur
            </p>
          </div>
          {/* Partners */}
          <div data-id="element-1085" data-mp="9jx5fu3ek">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1086" data-mp="3w4w65fer8zo0">
              Partners
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1087" data-mp="2j74cy3pzibmc">
              Ethnicity Matters (Media Partner)
              <br data-id="element-1088" data-mp="2eax5g6hxws2a" />
              Sikhiwiki
            </p>
          </div>
          {/* Supported By */}
          <div className="md:col-span-2 lg:col-span-3" data-id="element-1089" data-mp="2s6hl8t2dgu5h">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1090" data-mp="2o81uce3671ms">
              Supported By
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light mb-6" data-id="element-1091" data-mp="1viuw7g7moe22">
              Akal Steel (2005) Inc.
              <br data-id="element-1092" data-mp="29baqnsmgr3rd" />
              Sikh Heritage Museum of Canada
              <br data-id="element-1093" data-mp="24irdgwrouan3" />
              Sikh Foundation of Canada
            </p>
            <p className="text-amber-400 font-light text-xs tracking-[0.3em] uppercase mb-3" data-id="element-1094" data-mp="1gtf4ny09w4lb">
              Contributing Sikh University Alumni
            </p>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1095" data-mp="1crbrn4xygrxx">
              IIT Delhi (Delhi, India)
              <br data-id="element-1096" data-mp="26lfnh9kaa5vw" />
              Ivey Business School (London, Canada)
              <br data-id="element-1097" data-mp="26ntijieyri3g" />
              INSEAD (Fontainebleau, France • Singapore)
              <br data-id="element-1098" data-mp="2alr84mcnc67d" />
              University of Toronto (Toronto, Canada)
              <br data-id="element-1099" data-mp="2fmnj1jvf0sma" />
              University of Waterloo (Waterloo, Canada)
            </p>
          </div>
          {/* Special Thanks */}
          <div className="md:col-span-2 lg:col-span-3" data-id="element-1100" data-mp="2kl8e74vt8m3v">
            <h3 className="text-amber-400 font-light text-sm mb-4 tracking-[0.3em] uppercase border-b border-amber-400/30 pb-2" data-id="element-1101" data-mp="2pjrxsymxllt2">
              Special Thanks
            </h3>
            <p className="text-white/70 text-xs leading-relaxed tracking-wider uppercase font-light" data-id="element-1102" data-mp="2ycn7q5ncg5p6">
              AKAash Kundan Singh • Baani Kundan Kaur • Amardeep Singh • Jeevan
              Singh • Himmat Singh • Harman Kaur • Bibek Singh • Amandeep
              Dhaliwal • Suresh Singh Bhalla • Sabi Marwah • Lally Marwah • Gary
              Singh • Sat Gosal • Thakral Family (Singapore) • Sidhu Family
              (Singapore) • Sahni Family (Dubai) • Calais Family (Sydney) • Alg
              Family (London) • Mattharu Family (San Francisco) • Butter Chicken
              Cartel (Cancun)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};